<template>
    <div class="container">
        <div class="col-md-12">
            <h2>{{ labels.title }}</h2>
        </div>

        <b-container>
            <!-- Filtros principales - Estilo CargueBalance -->
            <b-row class="mb-4 align-items-center text-lg">
                <!-- Reporte -->
                <b-col md="3">
                    <label class="d-block fw-bold" style="font-size: 1.3rem;"><b>{{ labels.report }}</b></label>
                    <select v-model="selReporte" @click="iniciaPlan; fgl_consulta = false"
                        class="form-control form-control-lg">
                        <option value="">{{ labels.select }}</option>
                        <option v-for="reporte in listReporte" :key="reporte.id" :value="reporte.codigo">
                            {{ reporte.nombre }}
                        </option>
                    </select>
                </b-col>
                <!-- Vigencia -->
                <b-col md="3">
                    <label class="d-block fw-bold" style="font-size: 1.3rem;"><b>{{ labels.vigencia }}</b></label>
                    <select v-model="selVigencia" @click="iniciaPlan; fgl_consulta = false"
                        class="form-control form-control-lg">
                        <option value="">{{ labels.select }}</option>
                        <option v-for="vigencia in listVigencia" :key="vigencia.vigencia">
                            {{ vigencia.vigencia }}
                        </option>
                    </select>
                </b-col>

                <!-- Grupo -->
                <b-col md="3">
                    <label class="d-block fw-bold" style="font-size: 1.3rem;"><b>Grupo</b></label>
                    <select v-model="grupoId" @change="f_filterCompany" class="form-control form-control-lg">
                        <option value="">Todos los grupos</option>
                        <option v-for="grupo in listGrupos" :key="grupo.id" :value="grupo.id">
                            {{ grupo.nombre }}
                        </option>
                    </select>
                </b-col>

                <!-- Compañía -->
                <b-col md="3">
                    <label class="d-block fw-bold" style="font-size: 1.3rem;"><b>{{ labels.company }}</b></label>
                    <select v-model="companyId" @click="iniciaPlan; fgl_consulta = false"
                        class="form-control form-control-lg">
                        <option value="">{{ labels.select }}</option>
                        <option v-for="company in filteredCompany" :value="company.id" :key="company.id">
                            {{ company.acronym + " - " + company.nombre }}
                        </option>
                    </select>
                </b-col>
            </b-row>

            <!-- Botón Consultar -->
            <b-row class="mb-4 justify-content-center">
                <b-col md="12" class="text-center">
                    <b-button @click="consultaCuentas(); fgl_consulta = true" id="consult-btn" size="lg"
                        variant="outline-primary">
                        <b-icon icon="search" class="me-2"></b-icon>
                        {{ labels.consultar }}
                    </b-button>
                </b-col>
            </b-row>

            <!-- Resultados de la consulta -->
            <div v-if="fgl_consulta">
                <b-row class="mb-4 align-items-end">
                    <!-- Buscadores -->
                    <b-col md="3">
                        <label class="d-block fw-bold text-dark mb-2" style="font-size: 1.1rem;">{{
                            labels.searchByCuenta }}</label>
                        <b-form-input v-model="searchCuenta" @input="searchOnTableAcount" class="form-control"
                            placeholder="Buscar cuenta...">
                        </b-form-input>
                    </b-col>

                    <b-col md="3">
                        <label class="d-block fw-bold text-dark mb-2" style="font-size: 1.1rem;">{{ labels.searchByNiif
                        }}</label>
                        <b-form-input v-model="searchNiif" @input="searchOnTableNiif" class="form-control"
                            placeholder="Buscar por código o descripción...">
                        </b-form-input>
                    </b-col>

                    <b-col md="2" class="d-flex align-items-end">
                        <b-button @click="borraCriterio" variant="outline-secondary" class="w-100"
                            style="height: 38px;">
                            <b-icon icon="arrow-counterclockwise" class="me-2"></b-icon>
                            Limpiar
                        </b-button>
                    </b-col>

                    <b-col md="2" class="d-flex align-items-end">
                        <b-button variant="outline-secondary" @click="editVariasCuentas()" class="w-100"
                            style="height: 38px;">
                            <b-icon icon="pencil" class="me-2"></b-icon>
                            Editar múltiple
                        </b-button>
                    </b-col>

                    <!-- Selector de registros -->
                    <b-col md="2" class="d-flex align-items-end">
                        <b-form-select v-model="itemLimit" :options="limitOptions" size="md" style="width: 100%;"
                            @change="resetVisibleItems">
                        </b-form-select>
                    </b-col>
                </b-row>

                <!-- Contador -->
                <b-row class="mb-3">
                    <b-col md="12">
                        <div class="text-muted text-center">
                            Mostrando <strong>{{ visibleItems.length }}</strong> de
                            <strong>{{ listPlanCuentas.length }}</strong> registros
                        </div>
                    </b-col>
                </b-row>

                <!-- Tabla -->
                <b-row>
                    <b-col md="12">
                        <div class="table-responsive custom-scroll-container" ref="scrollContainer">
                            <table class="table table-hover table-bordered">
                                <thead style="background-color: #4a90e2;">
                                    <tr>
                                        <th scope="col" class="text-center text-white border-0"
                                            style="font-weight: 600;">Cuenta</th>
                                        <th scope="col" class="text-center text-white border-0"
                                            style="font-weight: 600;">Descripción</th>
                                        <th scope="col" class="text-center text-white border-0"
                                            style="font-weight: 600;">Niif</th>
                                        <th scope="col" class="text-center text-white border-0"
                                            style="font-weight: 600;">ESF</th>
                                        <th scope="col" class="text-center text-white border-0"
                                            style="font-weight: 600;">ERI</th>
                                        <th scope="col" class="text-center text-white border-0"
                                            style="font-weight: 600;">EFE</th>
                                        <th scope="col" class="text-center text-white border-0"
                                            style="font-weight: 600;">ECP</th>
                                        <th scope="col" class="text-center text-white border-0"
                                            style="font-weight: 600;">Interco</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="planCuent in visibleItems" :key="planCuent.id"
                                        @click="editCuenta(planCuent.id)" class="clickable-row">
                                        <td class="text-center"><strong class="text-dark">{{ planCuent.cuenta
                                        }}</strong></td>
                                        <td class="text-left">{{ planCuent.descripcion }}</td>
                                        <td class="text-left">{{ planCuent.nombre_niif }}</td>
                                        <td class="text-center">
                                            <b-badge :class="planCuent.esf == 'X' ? 'badge-indigo' : 'badge-light'"
                                                class="badge-lg">
                                                {{ planCuent.esf == "X" ? "SI" : "NO" }}
                                            </b-badge>
                                        </td>
                                        <td class="text-center">
                                            <b-badge :class="planCuent.eri == 'X' ? 'badge-indigo' : 'badge-light'"
                                                class="badge-lg">
                                                {{ planCuent.eri == "X" ? "SI" : "NO" }}
                                            </b-badge>
                                        </td>
                                        <td class="text-center">
                                            <b-badge :class="planCuent.efe == 'X' ? 'badge-indigo' : 'badge-light'"
                                                class="badge-lg">
                                                {{ planCuent.efe == "X" ? "SI" : "NO" }}
                                            </b-badge>
                                        </td>
                                        <td class="text-center">
                                            <b-badge :class="planCuent.ecp == 'X' ? 'badge-indigo' : 'badge-light'"
                                                class="badge-lg">
                                                {{ planCuent.ecp == "X" ? "SI" : "NO" }}
                                            </b-badge>
                                        </td>
                                        <td class="text-center">
                                            <b-badge v-if="planCuent.intercoDescripcion" class="badge-indigo badge-lg">
                                                {{ planCuent.intercoDescripcion }}
                                            </b-badge>
                                            <b-badge v-else class="badge-light badge-lg">
                                                {{ labels.noGroup }}
                                            </b-badge>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </b-col>
                </b-row>
            </div>

            <!-- Mensaje cuando no hay datos -->
            <div v-else class="mt-4 text-center">
                <div class="h4 text-muted">
                    <b-icon icon="inbox" class="me-2"></b-icon>
                    {{ labels.noData }}
                </div>
            </div>
        </b-container>

        <!-- Loading Spinner -->
        <div class="loadingSpinner" :class="{ active: isLoading }">
            <b-spinner variant="primary"></b-spinner>
        </div>

        <!-- Modales -->
        <Edit :showDialogEdit="showDialogEdit" @clicked="closeModal" @item-updated="updateItemInTable"
            :Item="itemSelected" :listNiif="listNiif" />
        <EditaVariasCuentas :showEditMasivo="showEditMasivo" :compVigSelect="selCompVig"
            :listadoCuentas="listPlanCuentas" :listadoNiif="listNiif" @reload="refrescaTabla" @clicked="closeModal" />
    </div>
</template>
<script>

import Company from "../../services/Company"
import PlanCuentas from "../../services/PlanCuentas"
import PlanConsolidacion from '../../services/PlanConsolidacion';
import TipoReporte from '../../services/TipoReporte';
import Edit from "./Edit.vue";
import EditaVariasCuentas from "./EditaVariasCuentas.vue";
import Balance from "../../services/BalanceNiif"

const toLower = (text) => {
    return text.toString().toLowerCase();
};

const searchByCuenta = (items, term) => {
    if (term) {
        return items.filter((item) =>
            toLower(item.cuenta).startsWith(term)
        );
    }
    return items;
};
const searchByNiif = (items, term) => {
    if (term) {
        const termLower = toLower(term);
        return items.filter((item) => {
            // Buscar por código numérico (como antes)
            if (item.niif == term) {
                return true;
            }
            // Buscar por texto en nombre_niif
            if (item.nombre_niif && toLower(item.nombre_niif).includes(termLower)) {
                return true;
            }
            return false;
        });
    }
    return items;
};

export default {
    name: "PlanCuentas",
    components: {
        Edit,
        EditaVariasCuentas
    },

    data: () => ({
        fgl_consulta: false,
        searchCuenta: null,
        searchNiif: null,
        listPlanCuentas: [],
        listPlanCuentasOrigen: [],
        listCompany: [],
        companiaUsuario: [],
        listVigencia: [],
        companyId: "",
        selVigencia: "",
        showDialogEdit: false,
        showEditMasivo: false,
        itemSelected: {},
        listFirstLevel: [],
        listSecondLevel: [],
        listNiif: [],
        isLoading: false,
        selCompVig: {},
        selReporte: "",
        listReporte: [],
        grupoId: "",
        listGrupos: [],
        filteredCompany: [],
        itemLimit: 100,
        visibleItems: [],
        limitOptions: [
            { value: 100, text: '100 registros' },
            { value: 200, text: '200 registros' },
            { value: 500, text: '500 registros' },
            { value: 0, text: 'Mostrar todo' }
        ]
    }),

    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Plan de cuentas",
                    searchByCuenta: "Buscar por Cuenta",
                    searchByNiif: "Buscar por Niif",
                    account: "Cuenta",
                    description: "Descripción",
                    levelFirst: "Primer nivel",
                    levelSecond: "Segundo nivel",
                    niif: "Niif",
                    esf: "esf",
                    eri: "eri",
                    efe: "efe",
                    ecp: "ecp",
                    interco: "interco",
                    select: "Seleccione...",
                    vigencia: "Vigencia..",
                    company: "Compañia..",
                    report: "Reporte..",
                    consultar: "Consultar",
                    first: "Ini",
                    previous: "Ant.",
                    next: "Sig.",
                    last: "Ult.",
                    edit: "Editar",
                    cuentaNiif: "Cuenta/Niif",
                    noGroup: "NO",
                    group: "Grupo",
                }
            } else {
                return {
                    title: "Chart of accounts",
                    searchByCuenta: "Search by account",
                    searchByNiif: "Search by Niif",
                    account: "Account",
                    description: "Description",
                    levelFirst: "Level first",
                    levelSecond: "Level second",
                    niif: "Niif",
                    esf: "esf",
                    eri: "eri",
                    efe: "efe",
                    ecp: "ecp",
                    interco: "interco",
                    select: "Select...",
                    vigencia: "Validity: ",
                    report: "Report:",
                    company: "Company: ",
                    consultar: "Consult",
                    first: "Fir",
                    previous: "Previous",
                    next: "Next",
                    last: "Last",
                    edit: "Edit",
                    cuentaNiif: "Account/NIIF",
                    noGroup: "NO",
                    group: "Group",
                }
            }
        }
    },

    methods: {
        iniciaPlan() {
            this.listPlanCuentas = []
            this.visibleItems = []
        },
        consultaCuentas() {
            this.isLoading = true

            // Realizar ambas llamadas en paralelo
            Promise.all([
                PlanCuentas.getCuentasPorCompaVigRepor(this.companyId, this.selVigencia, this.selReporte),
                PlanConsolidacion.getPlanConsPorCompVige(this.selVigencia, this.selReporte)
                // Quita esta línea: GruposIntercos.getAllGruposIntercos()
            ])
                .then(([resCuentas, resNiif]) => {
                    console.log('Datos CRUDOS del SP:', resCuentas.data.planCuentas[0]) // ← Agrega esto

                    this.listPlanCuentas = resCuentas.data.planCuentas.map(cuenta => ({
                        ...cuenta,
                        intercoDescripcion: cuenta.interco_descripcion
                    }))

                    console.log('Después del mapeo:', this.listPlanCuentas[0]) // ← Y esto

                    this.listPlanCuentasOrigen = [...this.listPlanCuentas]
                    this.listNiif = resNiif.data.planConsNiif
                    this.resetVisibleItems()
                })
                .catch((err) => {
                    console.log(err)
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        editCuenta(id) {
            const item = this.listPlanCuentas.find((r_plan) => r_plan.id == id)
            this.itemSelected = item
            this.showDialogEdit = true;
        },
        editVariasCuentas() {
            this.selCompVig.companyId = this.companyId
            this.selCompVig.vigencia = this.selVigencia
            this.selCompVig.codReporte = this.selReporte
            this.showEditMasivo = true
        },
        closeModal(value) {
            this.showDialogEdit = value;
            this.showEditMasivo = value
        },
        refrescaTabla(vigencia, idCompany, codReporte) {
            this.isLoading = true

            PlanCuentas.getCuentasPorCompaVigRepor(idCompany, vigencia, codReporte)
                .then((res) => {
                    this.listPlanCuentas = res.data.planCuentas.map(cuenta => ({
                        ...cuenta,
                        intercoDescripcion: cuenta.interco_descripcion
                    }))

                    this.resetVisibleItems()
                })
                .catch((err) => {
                    console.log(err)
                })
                .finally(() => {
                    this.isLoading = false
                    this.showDialogEdit = false
                    this.showEditMasivo = false
                })
        },
        borraCriterio() {
            this.searchCuenta = ''
            this.searchNiif = ''
            // Restaurar lista completa cuando se limpian filtros
            this.listPlanCuentas = this.listPlanCuentasOrigen
            this.resetVisibleItems()
        },
        searchOnTableAcount() {
            this.listPlanCuentas = searchByCuenta(this.listPlanCuentasOrigen, this.searchCuenta);
            if (this.searchCuenta == '') {
                this.listPlanCuentas = this.listPlanCuentasOrigen
            }
            this.resetVisibleItems()
        },
        searchOnTableNiif() {
            this.listPlanCuentas = searchByNiif(this.listPlanCuentasOrigen, this.searchNiif);
            if (this.searchNiif == '') {
                this.listPlanCuentas = this.listPlanCuentasOrigen
            }
            this.resetVisibleItems()
        },

        resetVisibleItems() {
            if (this.itemLimit === 0) {
                // Mostrar todos los registros
                this.visibleItems = [...this.listPlanCuentas];
            } else {
                this.visibleItems = this.listPlanCuentas.slice(0, this.itemLimit);
            }
        },

        f_filterCompany() {
            if (this.grupoId) {
                const grupoIdNum = this.grupoId.toString();
                this.filteredCompany = this.listCompany.filter(company => {
                    if (!company.id_grupos) return false;
                    const gruposCompania = company.id_grupos.split(',').map(id => id.trim());
                    return gruposCompania.includes(grupoIdNum);
                });
            } else {
                this.filteredCompany = this.listCompany;
            }
            this.companyId = "";
            this.fgl_consulta = false;
        },

        updateItemInTable(updatedItem) {
            // Encontrar el índice del item actualizado en la lista
            const index = this.listPlanCuentas.findIndex(item => item.id === updatedItem.id);

            if (index !== -1) {
                // Actualizar el item en la lista principal
                this.$set(this.listPlanCuentas, index, updatedItem);

                // También actualizar en la lista origen para mantener consistencia en los filtros
                const indexOrigen = this.listPlanCuentasOrigen.findIndex(item => item.id === updatedItem.id);
                if (indexOrigen !== -1) {
                    this.$set(this.listPlanCuentasOrigen, indexOrigen, updatedItem);
                }

                // Actualizar los items visibles
                this.resetVisibleItems();

            }
        },

        // MÉTODOS PARA CARGA SECUENCIAL
        async loadUserCompanies() {
            try {
                const userResult = await Balance.leaCompaniaUsuario();
                this.companiaUsuario = userResult.data.companiaUsuario;

                const companiesResult = await Company.getAllCompanies();
                const allCompanies = companiesResult.data.companies;

                const filteredCompanies = allCompanies.filter((company) => {
                    if (this.$store.state.userRole == 1) {
                        return true;
                    }

                    const userHasAccess = this.companiaUsuario.find(
                        (userCompany) =>
                            userCompany.id_usuario == this.$store.state.userId &&
                            userCompany.id_compania == company.id
                    );
                    return userHasAccess;
                });

                this.listCompany = filteredCompanies;
                this.filteredCompany = filteredCompanies; // Inicializar filteredCompany

            } catch (err) {
                console.error("Error loading companies:", err);
                throw err;
            }
        },

        async loadVigencias() {
            try {
                const result = await PlanCuentas.getVigenciaPlancuentas();
                this.listVigencia = result.data.getVigencia;
            } catch (err) {
                console.error("Error loading vigencias:", err);
                throw err;
            }
        },

        async loadReportTypes() {
            try {
                const res = await TipoReporte.getAllTipoReporte();
                this.listReporte = res.data.typeReport;
            } catch (err) {
                console.error("Error loading report types:", err);
                throw err;
            }
        },
        async loadGrupos() {
            try {
                const Grupo = await import("../../services/Grupo");
                const result = await Grupo.default.getAllGrupos();
                this.listGrupos = result.data.grupos;
            } catch (err) {
                console.error("Error loading grupos:", err);
            }
        }
    },

    mounted() {
        this.isLoading = true;

        // Secuenciar las llamadas para garantizar el orden correcto
        this.loadUserCompanies()
            .then(() => this.loadVigencias())
            .then(() => this.loadReportTypes())
            .then(() => this.loadGrupos())
            .catch((err) => {
                console.error("Error loading data:", err);
            })
            .finally(() => {
                this.isLoading = false;
            });
    }
}
</script>
<style src="../main.css"></style>
